module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "front-landing-page"
  }, [_c('md-header', {
    key: _vm.headerRefresh,
    attrs: {
      "icon": _vm.item.icon
    }
  }), _c('div', {
    staticClass: "content front"
  }, [_c('div', {
    staticClass: "box-banner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.item.banner && _vm.item.banner !== null && _vm.item.banner.length > 0) ? _c('carousel', {
    staticClass: "box-owl-carousel",
    attrs: {
      "items": 1,
      "loop": true,
      "autoHeight": true,
      "autoplay": true,
      "lazyLoad": true,
      "dots": true,
      "center": true,
      "nav": false
    }
  }, _vm._l((_vm.item.banner), function(banner, index) {
    return (banner.length > 0) ? _c('img', {
      staticClass: "item-banner",
      attrs: {
        "src": banner
      }
    }) : _vm._e()
  }), 0) : _vm._e()], 1)])]), _c('div', {
    staticClass: "box-pc"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.item !== null && _vm.item.name !== undefined && _vm.item.name.length > 0) ? _c('div', {
    staticClass: "title-pc"
  }, [_vm._v(_vm._s(_vm.item.name))]) : _vm._e(), _c('div', {
    ref: "boxInfo",
    staticClass: "item-pc-info",
    style: (_vm.stylesMaxHeight)
  }, [_c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.item.description)
    }
  }), (_vm.isMore) ? _c('div', {
    staticClass: "gradient"
  }) : _vm._e(), (_vm.isMore) ? _c('a', {
    staticClass: "view-more",
    on: {
      "click": _vm.showMore
    }
  }, [_vm._v(_vm._s(this.$t('home.view_more')) + " >>")]) : _vm._e()]), (_vm.item.user_public) ? _c('div', {
    ref: "boxTeacher",
    staticClass: "item-pc-teacher"
  }, [_c('div', {
    staticClass: "avatar"
  }, [(_vm.item.user_public && _vm.item.user_public.avatar !== undefined && _vm.item.user_public.avatar !== null && _vm.item.user_public.avatar.length > 0) ? _c('img', {
    attrs: {
      "src": _vm.item.user_public.avatar
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../../assets/images/home/swarm.svg")
    }
  })]), _c('div', {
    staticClass: "teacher-type"
  }, [_vm._v(_vm._s(this.$t('landing.teacher')) + ":")]), (_vm.item.user_public && _vm.item.user_public.fullname !== undefined) ? _c('div', {
    staticClass: "teacher-name"
  }, [_vm._v(_vm._s(_vm.item.user_public.fullname))]) : _vm._e(), (_vm.item.user_public && _vm.item.user_public.userquotes !== undefined) ? _c('div', {
    staticClass: "teacher-about",
    domProps: {
      "innerHTML": _vm._s(_vm.item.user_public.userquotes)
    }
  }) : _vm._e(), _c('button', {
    staticClass: "button active",
    on: {
      "click": function($event) {
        return _vm.publicTeacher(_vm.item.user_public)
      }
    }
  }, [_vm._v(_vm._s(this.$t('landing.teacher_view')))]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.chatBox
    }
  }, [_vm._v(_vm._s(this.$t('landing.teacher_chat')))])]) : _vm._e()])])]), (_vm.item.classes && _vm.item.classes !== null && _vm.item.classes.length > 0) ? _c('div', {
    staticClass: "box-pc-classes"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row custom-classes",
    attrs: {
      "id": "toClasses"
    }
  }, _vm._l((_vm.item.classes), function(classes) {
    return _c('div', [(!_vm.item.private) ? _c('ItemClasses', {
      attrs: {
        "pcID": _vm.item.id,
        "item": classes
      }
    }) : _vm._e()], 1)
  }), 0)])]), (_vm.item.user_public && _vm.item.user_public.id !== undefined && _vm.item.user_public.id !== null && _vm.item.user_public.id.length > 0) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('FrontCourse', {
    attrs: {
      "teacherID": _vm.item.user_public.id,
      "item": _vm.item
    }
  })], 1)]) : _vm._e(), (_vm.item.user_public && _vm.item.user_public.id !== undefined && _vm.item.user_public.id !== null && _vm.item.user_public.id.length > 0) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('FrontExercise', {
    attrs: {
      "teacherID": _vm.item.user_public.id,
      "item": _vm.item,
      "pcInfo": _vm.pcInfo
    }
  })], 1)]) : _vm._e(), (_vm.item.user_public && _vm.item.user_public.id !== undefined && _vm.item.user_public.id !== null && _vm.item.user_public.id.length > 0) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('FrontVideo', {
    attrs: {
      "teacherID": _vm.item.user_public.id,
      "item": _vm.item,
      "pcInfo": _vm.pcInfo
    }
  })], 1)]) : _vm._e(), (_vm.item.user_public && _vm.item.user_public.id !== undefined && _vm.item.user_public.id !== null && _vm.item.user_public.id.length > 0) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('FrontLesson', {
    attrs: {
      "teacherID": _vm.item.user_public.id,
      "item": _vm.item,
      "pcInfo": _vm.pcInfo
    }
  })], 1)]) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50d73be5","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Front/LandingPage/index.vue
// module id = 1557
// module chunks = 0